module.exports = __webpack_public_path__ + "static/media/27OCHA19.412bc13e.jpg";